import { buildTimestampControlPdf } from '../helpers/downloads/timestampControlPdfBuilder'
import { buildTimestampControlCsvRows } from '../helpers/downloads/timestampControlCsvBuilder'
import { buildActivityBreakdownPdf } from '../helpers/downloads/activityBreakdownPdfBuilder'
import { buildActivityBreakdownCsvRows } from '../helpers/downloads/activityBreakdownCsvBuilder'
import { useState } from 'react'
import { Box } from '@mui/material'
import { getCurrentDate } from '../../../helpers/formatDate'
import cookie from 'react-cookies'
import DownloadCsvPdfSplitButton from '../../../components/action_button/DownloadCsvPdfSplitButton'
import {
  buildRouteUserReportCsvRows,
  downloadCsvRows,
  exportRouteUserReportPDF
} from '../helpers/downloads/exportRouteUserReportFiles'

const UserReportDownloadComponent = ({
  activeTab,
  startDate,
  endDate,
  salesmanName,
  business_uid,
  formatActivityName,
  onLoadDownloadData,
  isDownloadFetching = false,
  isDataUpdating = false,
  isTimestampSameDay,
  timestampSummary = {},
  routeCartData,
  geofenceSegment = 'general',
  salesmanCode,
  business,
  activityOverview,
  activityEffectivenessSegment = 'general'
}) => {
  const supervisorName = cookie.load('user_name')
  const [isDownloading, setIsDownloading] = useState(false)
  const [downloadLabel, setDownloadLabel] = useState('')

  const usernameWithoutSpaces = salesmanName?.replace(/\s/g, '') || 'usuario'

  const handleRouteDownload = async (type) => {
    if (isDataUpdating || isDownloadFetching || isDownloading) return
    setIsDownloading(true)
    setDownloadLabel('Descargando...')

    try {
      const downloadData = await onLoadDownloadData('route_execution')
      const routeExecutionDownloadData = downloadData?.results || []
      const activityDownloadData = downloadData?.activityDetails || []
      const timestampDownloadData = downloadData?.timestampDetails || []
      const exportBusiness = downloadData?.business ||
        business || { name: cookie.load('business_name') }

      if (type === 'pdf') {
        exportRouteUserReportPDF({
          routeCartData,
          geofenceSegment,
          salesmanCode,
          business: exportBusiness,
          routeExecutionDownloadData,
          activityDownloadData,
          timestampDownloadData,
          salesmanName,
          business_uid,
          startDate,
          endDate,
          formatActivityName
        })
      } else {
        const rows = buildRouteUserReportCsvRows({
          routeCartData,
          geofenceSegment,
          salesmanCode,
          business: exportBusiness,
          routeExecutionDownloadData,
          activityDownloadData,
          timestampDownloadData,
          formatActivityName,
          salesmanName,
          supervisorName,
          startDate,
          endDate
        })

        downloadCsvRows(
          rows,
          `Reporte_EjecucionPlanDeVisitas_${usernameWithoutSpaces}_${business_uid}_${getCurrentDate()}.csv`
        )
      }
    } catch (error) {
      console.error('Route download error:', error)
      window.alert('No se pudo generar el archivo. Intenta nuevamente.')
    } finally {
      setIsDownloading(false)
      setDownloadLabel('')
    }
  }

  const handleSingleTabDownload = async (type) => {
    if (isDataUpdating || isDownloadFetching || isDownloading) return

    const isActivityTab = activeTab === 'activity_breakdown'
    const filenameBase = isActivityTab
      ? `DesgloseDeActividades_${usernameWithoutSpaces}_${business_uid}_${getCurrentDate()}`
      : `ControlDeHorario_${usernameWithoutSpaces}_${business_uid}_${getCurrentDate()}`

    setIsDownloading(true)
    setDownloadLabel('Descargando...')

    try {
      const downloadData = await onLoadDownloadData(activeTab)
      const results = downloadData?.results || []
      if (isActivityTab) {
        const options = {
          results,
          overview: activityOverview,
          effectivenessSegment: activityEffectivenessSegment,
          formatActivityName,
          startDate,
          endDate,
          salesmanName,
          salesmanCode,
          business: downloadData?.business || business || { name: cookie.load('business_name') }
        }
        if (type === 'pdf') buildActivityBreakdownPdf(options).save(`${filenameBase}.pdf`)
        else downloadCsvRows(buildActivityBreakdownCsvRows(options), `${filenameBase}.csv`)
        return
      }

      const options = {
        results,
        timestampSummary,
        isTimestampSameDay,
        startDate,
        endDate,
        salesmanName,
        salesmanCode,
        business: downloadData?.business || business || { name: cookie.load('business_name') }
      }
      if (type === 'pdf') buildTimestampControlPdf(options).save(`${filenameBase}.pdf`)
      else downloadCsvRows(buildTimestampControlCsvRows(options), `${filenameBase}.csv`)
    } catch (error) {
      console.error('User report download error:', error)
      if (error.name !== 'AbortError')
        window.alert('No se pudo generar el archivo. Intenta nuevamente.')
    } finally {
      setIsDownloading(false)
      setDownloadLabel('')
    }
  }

  const handleDownload = (type) => {
    if (activeTab === 'route_execution') {
      handleRouteDownload(type)
      return
    }

    handleSingleTabDownload(type)
  }

  return (
    <Box>
      <DownloadCsvPdfSplitButton
        label={isDataUpdating ? 'Actualizando...' : downloadLabel || 'Descargar'}
        disabled={isDownloading || isDownloadFetching || isDataUpdating}
        onExportCsv={() => handleDownload('csv')}
        onExportPdf={() => handleDownload('pdf')}
      />
    </Box>
  )
}

export default UserReportDownloadComponent
